module.exports = "/img/12.6d539a.webp";